import React from 'react';
import './Card.css';

/**
 * Reusable Card component for displaying content in a container
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Card content
 * @param {string} props.title - Optional card title
 * @param {boolean} props.interactive - Whether the card should have hover effects
 * @param {function} props.onClick - Click handler function (for interactive cards)
 * @param {string} props.className - Additional CSS class names
 */
const Card = ({
  children,
  title,
  interactive = false,
  onClick,
  className = '',
  ...rest
}) => {
  const baseClass = 'ui-card';
  const interactiveClass = interactive ? `${baseClass}--interactive` : '';
  const classes = [baseClass, interactiveClass, className].filter(Boolean).join(' ');

  return (
    <div 
      className={classes} 
      onClick={interactive ? onClick : undefined}
      {...rest}
    >
      {title && <div className="ui-card__title">{title}</div>}
      <div className="ui-card__content">
        {children}
      </div>
    </div>
  );
};

export default Card;